import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Avatar } from '../Avatar';
import { getDisplayName } from '../../utils/commentAvatar';
// Attribution line on a saved feature's info dialog. Unlike the tree rows,
// this shows for every author including the current user: the dialog is a
// detail view, so the answer to "who drew this" belongs there either way.
export const DrawnBy = ({ author }) => {
    if (!author)
        return null;
    return (_jsxs("div", { className: "flex items-center gap-2 mb-3 min-w-0", children: [_jsx("span", { className: "text-xs flex-shrink-0", style: { color: 'var(--dew)' }, children: "Drawn by" }), _jsx(Avatar, { userId: author.userId, commentColor: author.commentColor, photoUrl: author.avatarUrl, source: author, size: 16 }), _jsx("span", { className: "text-xs truncate", style: { color: 'var(--sand)' }, children: getDisplayName(author) })] }));
};
